import { combineReducers } from "redux";
import AgencyReducer from "@/redux/reducers/fetchStoreData";
import DropDownReducer from "@/redux/reducers/fetchDropDownData";
import IncidentReducer from "@/redux/reducers/incidentReducer";
import OffenceReducer from "@/redux/reducers/offenceReducer";
import NameReducer from "@/redux/reducers/nameReducer";
import VehicleReducer from "@/redux/reducers/vehicleReducer";
import PropertyReducer from "@/redux/reducers/propertyReducer";
import ArrestReducer from "@/redux/reducers/arrestReducer";
import MissingPersonReducer from "@/redux/reducers/missingPersonReducer";
import FieldInterviewReducer from "@/redux/reducers/FieldInterviewReducer";
import ipReducer from "@/redux/reducers/ipReducer";

// CAD
import CADDropDownReducer from "@/CADRedux/reducers/fetchCADDropDownData";


export default combineReducers({
    Agency: AgencyReducer,
    DropDown: DropDownReducer,
    Incident: IncidentReducer,
    Offence: OffenceReducer,
    Name: NameReducer,
    Vehicle: VehicleReducer,
    Property: PropertyReducer,
    Arrest: ArrestReducer,
    MissingPerson: MissingPersonReducer,
    FieldInterview: FieldInterviewReducer,
    Ip: ipReducer,

    // CAD
    CADDropDown: CADDropDownReducer,
});    